// extracted by mini-css-extract-plugin
export default {"wrapper":"SwipeOrRotate_wrapper__dKSZ6","icon":"SwipeOrRotate_icon__taFg9"};